export const dashboardConstants = {
  SUMMARY_REQUEST: 'GET_SUMMARY_REQUEST',
  SUMMARY_SUCCESS: 'GET_SUMMARY_SUCCESS',
  SUMMARY_FAILURE: 'GET_SUMMARY_FAILURE',
};
